export function getUrlId(url, path) {
  const regex = new RegExp(`/${path}/(\\d+)`);
  const match = url.match(regex);
  return match ? match[1] : null;
}